/* @flow */
/* eslint-disable babel/no-invalid-this */
import Backstage from "nexia_mobile/backstage";
import type { AdvancedInfoFeature, AdvancedInfoItem } from "./types";
import type {
  BackstageUrl,
  HumanReadableString,
  ServerResponse,
} from "nexia_mobile/api/types";

export default function AdvancedInfo(feature: AdvancedInfoFeature) {
  this.getAdvancedInfoItems = () => feature.items;

  this.getAdvancedInfoDisplayed = () => this.get("advancedInfoDisplayed");
  this.setAdvancedInfoDisplayed = () => this.set("advancedInfoDisplayed", true);
  this.unsetAdvancedInfoDisplayed = () => this.unset("advancedInfoDisplayed");

  this.setAdvancedInfoLoading = (key) => this.set("advancedInfoLoading", key);
  this.unsetAdvancedInfoLoading = () => this.unset("advancedInfoLoading");

  this.setAdvancedInfoLoadedValue = (key, value) =>
    this.set(
      "advancedInfoLoadedValues",
      Object.assign({}, this.get("advancedInfoLoadedValues"), {
        [key]: { value, time: Date.now() },
      })
    );
  this.unsetAdvancedInfoLoadedValue = (key) => {
    const newLoadedValues = Object.assign(
      {},
      this.get("advancedInfoLoadedValues")
    );
    delete newLoadedValues[key];
    this.set("advancedInfoLoadedValues", newLoadedValues);
  };
  this.getAdvancedInfoLoadedValue = (key) =>
    (this.get("advancedInfoLoadedValues") || {})[key] || {};

  this.makeAdvancedInfoRequest = ({
    label: key,
    load_link: loadLink,
    timeout_message: timeoutMessage,
  }: AdvancedInfoItem) => {
    if (!loadLink) return Promise.reject(Error("An error occurred."));
    this.setAdvancedInfoLoading(key);
    return new Promise((resolve, reject) => {
      $.ajax({
        url: loadLink.href,
        method: loadLink.method || "POST",
        dataType: "json",
        error: (_jqxhr, textStatus, errorThrown) =>
          reject(Error(`${textStatus} - ${errorThrown}`)),
        success: resolve,
      });
    })
      .then(
        (
          response: ServerResponse<BackstageUrl>
        ): Promise<?HumanReadableString> => {
          return new Promise((resolve, reject) => {
            new Backstage(response.result.polling_path, {
              success: (result) =>
                resolve(result && result.options && result.options.message),
              error: (_serverErrors, _xhr, options) =>
                reject(
                  Error((options && options.message) || "An error occurred.")
                ),
              maxRequestsReached: () => reject(Error(timeoutMessage)),
              maxRequestsCount: 60,
            }).startPolling();
          });
        }
      )
      .catch((err) => {
        this.unsetAdvancedInfoLoading();
        throw err;
      })
      .then((result: ?HumanReadableString): ?HumanReadableString => {
        this.unsetAdvancedInfoLoading();
        return result;
      });
  };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/advanced_info.js